import axiosClient from "../axiosClient";

export const camVideoQuality = {
    getCamVideoQuality: (params) => {
        // camera_code: aa
        return axiosClient.get("/camVideoQuality/get-cam-video-quality/", {
            params: params,
        })
    },
    getListCamVideoQuality: (params) => {
        // camera_code: aaa
        // video_quality: 480p
        return axiosClient.get("/camVideoQuality/get-list-cam-video-quality/", {
            params: params
        })
    },
    getListQualityByMain: (params) => {
        return axiosClient.get('/videoQuality/get-list-video-quality/', {
            params: {
                main_source: params
            }
        })
    }
}